import { createContext, useContext, useState, ReactNode } from "react";
import { Doctor } from "../types/auth.types";
import { Surgery } from "../types/patient.types";
import { AdminStatus } from "../types/admin.types";
import { AssinaturaStatusResponse, Papel } from "../types/billing.types";

// Dados do usuário logado vindos do servidor. Nada aqui é persistido:
// tudo é re-buscado no bootstrap da sessão (useSessionBootstrap).

const EMPTY_DOCTOR: Doctor = {
  id: "",
  email: "",
  nome: "",
  crm: "",
  especialidade: "",
  total_pacotes_cirurgia: 0,
  total_pacotes_opme: 0,
  total_recursos: 0,
  total_resumo_com_referencias: 0,
  role: "",
  companies: [],
  hospitals: [],
  reservas: [],
};

function useSessionState() {
  const [metadata, setMetadata] = useState<Doctor>(EMPTY_DOCTOR);
  // `null` = ainda não verificado (gate da rota/menu de admin).
  const [adminStatus, setAdminStatus] = useState<AdminStatus | null>(null);
  // Fonte de verdade de acesso/plano (GET /billing/assinatura ou, logo após o
  // onboarding, OnboardingResponse.direitos). `null` = ainda não verificado.
  const [billing, setBilling] = useState<AssinaturaStatusResponse | null>(null);
  // Papel na organização. Só o onboarding retorna; `null` = desconhecido, e a
  // UI de gestão de cobrança deve tratar como "esconder", nunca "mostrar".
  const [papel, setPapel] = useState<Papel | null>(null);
  // Pedidos salvos do médico (GET por useOrdersApi), compartilhados entre
  // Pedidos salvos e o passo "Selecionar pedido" de Recursos.
  const [surgeries, setSurgeries] = useState<Surgery[]>([]);

  return {
    metadata, setMetadata,
    adminStatus, setAdminStatus,
    billing, setBilling,
    papel, setPapel,
    surgeries, setSurgeries,
  };
}

export type SessionState = ReturnType<typeof useSessionState>;

const SessionContext = createContext<SessionState | undefined>(undefined);

export const SessionProvider = ({ children }: { children: ReactNode }) => (
  <SessionContext.Provider value={useSessionState()}>{children}</SessionContext.Provider>
);

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) throw new Error("useSession deve ser usado dentro de um SessionProvider");
  return context;
};
